import { baseURL } from '@/httpService/API';
import { hMacAjax as fetch } from 'grt-tool-lib-front';
let orgUrl = baseURL + '/apaas-system-service';
export let url = {
    // 组织树
    orgTreeListByName: `${orgUrl}/organization/v1/tree`, //组织树列表
    // 获取自主注册配置的组织列表
    improveOrgList: `${baseURL}/grt-student-service/open/student/v1/student-invite/org/list`
};

//通过组织名称组织树列表
export async function handleOrgTreeListByName(data) {
    return fetch.get(url.orgTreeListByName, { ...data });
}

//获取自主注册配置的组织列表
export async function handleImproveOrgList() {
    return fetch.get(url.improveOrgList);
}
